<template>
    <div>
        <p v-if="educationLevelName"><strong>Уровень образования:</strong> {{ educationLevelName }}</p>
        <p v-if="data.startDate"><strong>Дата начала:</strong> {{ getFormattedDate(data.startDate) }}</p>
        <p v-if="data.finishDate || data.isUntilNow"><strong>Дата окончания:</strong> {{ data.finishDate
            ? getFormattedDate(data.finishDate)
            : data.isUntilNow
                ? "По настоящее время"
                : "" }}</p>
        <p v-if="institutionName"><strong>Образовательное учреждение:</strong> {{ institutionName }}</p>
        <p v-if="specialityName"><strong>Специальность:</strong> {{ specialityName }}</p>
        <p v-if="data.isHonorDegree"><strong>Диплом с отличием:</strong> {{ data.isHonorDegree ? "Да" : "Нет" }}</p>
    </div>
</template>

<script>
import {getFormattedDate} from "@/tools/moment-date";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "ExpertPanelReviewAboutEducation",
    methods: {
        ...mapActions('data', ['loadRegistryItemsByIDs']),
        getFormattedDate,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters('data', ['getRegistryValueById']),
        educationLevelName() {
            return this.getRegistryValueById(this.data.educationLevelId);
        },
        institutionName() {
            return this.getRegistryValueById(this.data.institutionId);
        },
        specialityName() {
            return this.getRegistryValueById(this.data.specialityId);
        },
    },
    mounted() {
        this.loadRegistryItemsByIDs({ids: [this.data.educationLevelId, this.data.institutionId, this.data.specialityId]});
    },
};
</script>

<style scoped>

</style>